<template lang="pug">
login-wrapper(childClass="box-login", :promo="promo")
  slot
    legend Регистрация
    p(v-if="promoText", v-html="promoText")
    .form-group(:class="{'has-error': !validation.email.valid}")
      .vfl-field.input-group(style="width: 100%;")
        input(
            type='text', 
            v-model='params.email', 
            required="", 
            @focus="validation.email.valid = true",
            ref='email',
            @keyup.enter="onEnter('email')"
        )
        span.field-underline
        label Email
            //- span(v-if='!validation.email.valid', v-html="requiredNotice")
      span.help-block.error(v-if="!validation.email.valid") {{ validation.email.message }}
    .form-group(:class="{'has-error': !validation.phone.valid}")
      .vfl-field.input-group(style="width: 100%;")
        the-mask(
            type='tel', 
            mask="+7 (###) ###-##-##", v-model='params.phone', 
            required="", 
            @focus.native="phoneFocus",
            ref='phone',
            @keyup.native.enter="onEnter('phone')"
        )
        span.field-underline
        label Номер телефона
      span.help-block.error(v-if="!validation.phone.valid") {{ validation.phone.message}} 
        //- span(v-if='!validation.phone.valid', v-html="requiredNotice")
            //- span(v-if=)
    .form-actions
      button.btn.btn-primary.pull-right(@click.prevent='registrate')
        | Далее
    p.margin-top-20 Если у Вас уже есть аккаунт – тогда 
        router-link(:to="{name: 'Login'}")
          |  Вам сюда
        | .
    p.help-block.margin-top-10 Нажимая на кнопку, вы даете согласие на обработку персональных данных и соглашаетесь c политикой конфиденциальности и офертой 
        a(href="http://salesbeat.pro/oferta") http://salesbeat.pro/oferta
    p.margin-top-20.help-block.error(v-if="errorMessage") {{ errorMessage }}

</template>

<script>
import LoginWrapper from '@/components/auth/LoginWrapper';

const promoFromNameMapping = {
    sdek: 'СДЭК',
    pro_sales: 'ProSales',
    magazin_lab: 'Magazin-Lab',
    filinibober: 'Filinibober',
    good_production: 'Good production',
    'internet.seo.2014': 'Internet SEO',
    'KPI agency': 'KPI agency',
    'gawrilovadiana': 'Диана Гаврилова',
    heplist: 'Helpist',
    'internet-expert.ru': 'Интернет-Эксперт',
    'salut': 'Студия Салют',
    'neprostokorobka': 'neprostokorobka.ru'
};

export default {
    name: 'PrimaryRegistration',
    components: {
        LoginWrapper
    },
    methods: {
        registrate() {
            //
            if (this.validate()) {
                this.$store.dispatch('primaryRegistration', this.params)
                    .catch(({errorMessage, errorList}) => {
                        this.errorMessage = errorMessage;
                        this.errorList = errorList;
                        this.markInvalid();
                    });
                fbq('track', 'Lead');
                ga('send', 'event', 'registration', 'registration');
                yaCounter49850311.reachGoal('registration');
            }
        },
        markInvalid() {
            for (let error of this.errorList) {
                this.validation[error.field].valid = false;
                this.validation[error.field].message = error.message;
            }
        },
        validate() {
            let valid = true;
            for (let field of ['email', 'phone']) {
                if (!this.params[field]) {
                    this.validation[field].valid = valid = false;
                    this.validation[field].message = this.requiredNotice;
                }
                if (this.params.phone && this.params.phone.length != 10) {
                    this.validation.phone.valid = valid = false;
                    this.validation.phone.message = 'Пожалуйста, укажите верный номер телефона';
                }
            }
            return valid;
        },
        phoneFocus() {
            this.validation.phone.valid = true;
            if (!this.params.phone) this.params.phone = '+7 (';
        },
        /**
        *   Если другое (не под фокусом) заполнено – вызываем ``registrate``,
        *   иначе – переводим фокус на другое поле
        **/
        onEnter(field) {
            const otherField = {'email': 'phone', 'phone': 'email'}[field];
            if (this.params[otherField]) {
                this.registrate();
            } else {
                if (otherField === 'phone') {
                    this.$refs.phone.$el.focus();
                } else {
                    this.$refs.email.focus();
                }
            }
        }
    },
    data() {
        let email = this.$cookie.get('registerEmail') || null,
            promoText = null,
            promoFromName = null;

        if (email && email.startsWith('"') && email.endsWith('"')) {
            email = email.slice(1, -1);
        }

        const promo = this.$cookie.get('promo') || null;
        if (promo) {
            promoFromName = promoFromNameMapping[promo] || '';
            promoFromName && (promoFromName = `от <b>${promoFromName}</b> `);
            promoText = `После регистрации Вас ждёт подарок ${promoFromName} – 
                        две бесплатные недели использования <b>Salesbeat</b> 🎉`;
        }

        return {
            params: {
                email,
                phone: this.$cookie.get('registerPhone') || null
            },

            requiredNotice: 'Обязательное поле',
            validation: {
                email: {valid: true, message: null},
                phone: {valid: true, message: null}
            },
            errorMessage: this.$cookie.get('registerErrorMessage') || null,
            errorList: this.$cookie.get('registerErrorList') || [],

            promo,
            promoText
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/PrimaryRegistration.vue